import YouTubeIconComponent from './youtubeIcon.component';

export const youtubeIconModule = {
	name: 'youtubeIconComponent',
};

export default angular
	.module(youtubeIconModule.name, [])
	.component('youtubeIcon', new YouTubeIconComponent()).name;
